export const PERSONA_PROMPT_VERSION = 1

export const PERSONA_OPTIONS = [
  {
    id: 'architectural_professional',
    label: 'Architect/architectural technologist',
  },
  { id: 'planning_consultant', label: 'Planning consultant' },
  { id: 'building_control', label: 'Building control professional' },
  { id: 'builder_contractor', label: 'Builder/contractor' },
  {
    id: 'engineer_specialist_consultant',
    label: 'Engineer/specialist consultant',
  },
  {
    id: 'developer_property_professional',
    label: 'Developer/property professional',
  },
  { id: 'homeowner_client', label: 'Homeowner/client' },
  { id: 'student_educator', label: 'Student/educator' },
  { id: 'other', label: 'Other' },
] as const

export type PersonaId = (typeof PERSONA_OPTIONS)[number]['id']

export const PERSONA_IDS = PERSONA_OPTIONS.map((option) => option.id) as [
  PersonaId,
  ...Array<PersonaId>,
]
